/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { AirlineRefundMethodFromJSON, AirlineRefundMethodToJSON, } from './AirlineRefundMethod.js';
import { CfarCreateExerciseItineraryFromJSON, CfarCreateExerciseItineraryToJSON, } from './CfarCreateExerciseItinerary.js';
import { CreateAirlineCfarSessionRequestFromJSON, CreateAirlineCfarSessionRequestToJSON, } from './CreateAirlineCfarSessionRequest.js';
/**
 * Check if a given object implements the CreateCfarContractExerciseRequest interface.
 */
export function instanceOfCreateCfarContractExerciseRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "itinerary" in value;
    isInstance = isInstance && "pnrReference" in value;
    isInstance = isInstance && "extAttributes" in value;
    return isInstance;
}
export function CreateCfarContractExerciseRequestFromJSON(json) {
    return CreateCfarContractExerciseRequestFromJSONTyped(json, false);
}
export function CreateCfarContractExerciseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'contractId': !exists(json, 'contract_id') ? undefined : json['contract_id'],
        'itinerary': CfarCreateExerciseItineraryFromJSON(json['itinerary']),
        'emailAddress': !exists(json, 'email_address') ? undefined : json['email_address'],
        'pnrReference': json['pnr_reference'],
        'airlineRefundPenalty': !exists(json, 'airline_refund_penalty') ? undefined : json['airline_refund_penalty'],
        'airlineRefundMethod': !exists(json, 'airline_refund_method') ? undefined : AirlineRefundMethodFromJSON(json['airline_refund_method']),
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'extAttributes': json['ext_attributes'],
        'session': !exists(json, 'session') ? undefined : CreateAirlineCfarSessionRequestFromJSON(json['session']),
        'callbackUrl': !exists(json, 'callback_url') ? undefined : json['callback_url'],
        'redirectbackUrl': !exists(json, 'redirectback_url') ? undefined : json['redirectback_url'],
    };
}
export function CreateCfarContractExerciseRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'contract_id': value.contractId,
        'itinerary': CfarCreateExerciseItineraryToJSON(value.itinerary),
        'email_address': value.emailAddress,
        'pnr_reference': value.pnrReference,
        'airline_refund_penalty': value.airlineRefundPenalty,
        'airline_refund_method': AirlineRefundMethodToJSON(value.airlineRefundMethod),
        'currency': value.currency,
        'ext_attributes': value.extAttributes,
        'session': CreateAirlineCfarSessionRequestToJSON(value.session),
        'callback_url': value.callbackUrl,
        'redirectback_url': value.redirectbackUrl,
    };
}
